import styled from 'styled-components';

export const CookieBanner = styled.div`
  position: fixed;
  bottom: 20px;
  transform: translateX(0%);
  z-index: 1;
  max-width: 500px;
  width: 90%;
  left: 1%;

  /* Media query for mobile */
  @media (max-width: 768px) {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
`;
